export const environment = {
    production: true,
    hmr       : false,

    // API
    urlBase: 'https://bimux.es/api/',

    // client credentials
    clientId: '1',
    clientSecret: 'WfYnD9h04w0RfuiVVVzKftYNJDtVulCd3WIictkH',

    // powerbi credentials
    powerbi: {
        groupId: '9db89de0-db17-4d36-af51-4438d4f51cd1',
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts